<div class="keys-menu">
  <div class="keys-menu-header">
    <h3>Keys</h3>
    <mat-icon class="close-icon" (click)="closeMenu()">close</mat-icon>
  </div>
  <ul class="list">
    @for (item of defaultKeys; track item) {
      <li class="list-item">
        <span class="selectable copy">{{ item }}</span>
      </li>
    }
  </ul>
</div>
